import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'
import NotFound from '../Pages/NotFound'

import ManageCategory from './Ecommerce/ManageCategory'
import ManageBrand from './Ecommerce/ManageBrand'
import ManageVariant from './Ecommerce/ManageVariant'
import ManageWarehouse from './Ecommerce/ManageWarehouse'
import ManageInventory from './Ecommerce/ManageInventory'
import ManageSupplier from './Ecommerce/ManageSupplier'
import ManageEcommerceProduct from './Ecommerce/ManageEcommerceProduct'
import ManageEcommerceOrder from './Ecommerce/ManageEcommerceOrder'

const subList = {
  ManageCategory: <ManageCategory />,
  ManageBrand: <ManageBrand />,
  ManageVariant: <ManageVariant />,
  ManageWarehouse: <ManageWarehouse />,
  ManageInventory: <ManageInventory />,
  ManageSupplier: <ManageSupplier />,
  ManageEcommerceProduct: <ManageEcommerceProduct />,
  ManageEcommerceOrder: <ManageEcommerceOrder />
}

const SubComponent = ({subname = 'list'}) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const EcommercePage = ({location, match}) => <SubComponent subname={match.params.sub} location={location} />
export default EcommercePage



// WEBPACK FOOTER //
// ./src/Pages/EcommercePage.js